/**
 * Comment-related strings.
 */
import React from 'react';
import '../Comment/CommentCard.less';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Icons from '../ui/IconButton/Icons';

const WIP = <b>WIP</b>;
const invoiceButton = <FontAwesomeIcon icon={Icons.INVOICE.reactIcon} size={'lg'}/>;

export default {
    d_title: 'Work in Progress',
    h_title: <div>
        <p>{WIP}, or <b>Work in Progress</b>, is work that has been completed but not invoiced.</p>
        <p>By default, {WIP} will show all un-invoiced work, but you can change the date range using
            the <b>Start</b> and <b>Through</b> dates below.</p>
        <p>{WIP} is organized by client and case, and lists relevant info like Labor, Expenses, Total (of Labor and
            Expenses), the number of Transactions (payments, withdrawals, etc), and the amount currently in Trust.</p>
        <p>To invoice {WIP}, you can either click the <span
            style={{color: 'darkgreen'}}>{invoiceButton} Invoice</span> button on the right of the entry,
            or you can select multiple clients and cases and click the <span
                style={{color: 'darkgreen'}}>{invoiceButton} Invoice All</span> button above the entry
            list.</p>
        <p>Clicking on an entry in {WIP} will show a breakdown of the labor, expenses and transactions for that client
        and case.</p>
    </div>
};